<template>
  <base-layout>
    <template v-slot:header>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Osnovne informacije
      </h1>
    </template>
    <template v-slot:default>
      <form class="space-y-8 divide-y divide-gray-200">
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Osnovne informacije o promociji
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                Pre početka promocije neophodno je popuniti tražene informacije. Moguća je i naknadna promena ovoh podataka nakon početka promocije.
              </p>
          </div>

          <div>
            <div class="mt-6">
              <fieldset class="mt-6">
                <div>
                  <legend class="text-base font-medium text-gray-900">
                    Tip promocije
                  </legend>
                </div>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input
                        id="sa_poklonom"
                        name="promotion_type"
                        type="radio"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        v-model="promotionSample"
                        value="1"
                    >
                    <label for="sa_poklonom" class="ml-3 block text-sm font-medium text-gray-700">
                      Sa poklonom
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input
                        id="sa_popustom"
                        name="promotion_type"
                        type="radio"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        v-model="promotionSample"
                        value="2"
                    >
                    <label for="sa_popustom" class="ml-3 block text-sm font-medium text-gray-700">
                      Sa popustom
                    </label>
                  </div>
                </div>
              </fieldset>
              <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-6 max-w-xl">
                  <label for="associates" class="text-base font-medium text-gray-900">
                    Saradnice
                  </label>
                  <p class="mt-1 text-sm text-gray-500">
                    Korisnička imena saradnica na hol promociji.
                  </p>
                  <div class="flow-root my-3" v-if="teamMates.length">
                    <ul class="divide-y divide-gray-200">
                      <li class="py-4" v-for="(mate, index) in teamMates" :key="index">
                        <div class="flex items-center space-x-4">
                          <span class="h-8 w-8 rounded-full overflow-hidden bg-gray-100">
                            <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                          </span>
                          <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 truncate">
                              {{ mate.username }}
                            </p>
                          </div>
                          <div>
                            <a
                                href="#"
                                class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                                @click.prevent="removeMate(mate.username)"
                            >
                              Ukloni
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>


                  <div class="mt-1 flex rounded-md shadow-sm">
                    <div class="relative flex items-stretch flex-grow focus-within:z-10">
                      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <!-- Heroicon name: solid/users -->
                        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                        </svg>
                      </div>
                      <input
                          type="text"
                          name="email"
                          id="email"
                          class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300"
                          placeholder="Korisničko ime"
                          @keyup="searchNewTeamMate"
                          ref="searchTerm"
                      >
                    </div>

                    <button
                        class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                        @click.prevent="clearSearchTerm"
                    >
                      Resetuj
                    </button>
                  </div>
                  <div class="flow-root my-3" v-if="potentialTeamMates.length">
                    <ul class="divide-y divide-gray-200">
                      <li class="py-4" v-for="(mate, index) in potentialTeamMates" :key="index">
                        <div class="flex items-center space-x-4">
                          <span class="h-8 w-8 rounded-full overflow-hidden bg-gray-100">
                            <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                          </span>
                          <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 truncate">
                              {{ mate.username }}
                            </p>
                          </div>
                          <div>
                            <a
                                href="#"
                                class="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                                @click.prevent="addToTeamMates(mate.id, mate.username)"
                            >
                              Dodaj
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-6">
                  <label for="cover_photo" class="text-base font-medium text-gray-900">
                    Fotografija pulta
                  </label>
                  <div class="mt-1 flex items-center">
                    <span class="h-12 w-12 rounded-full overflow-hidden bg-gray-100">
                      <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </span>
                    <input type="file" accept="image/*" @change="uploadImage($event)" id="file-input">
                    <div class="loader" v-if="showLoader"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-5">
          <div class="flex justify-end">
            <button
                type="button"
                class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="goBack"
            >
              Otkaži
            </button>
            <button
                v-if="imageId"
                class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click.prevent="submitCreatePromotion"
            >
              Nastavi
            </button>
            <button
                v-else
                class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click.prevent="showModal = true"
            >
              Nastavi
            </button>
          </div>
        </div>
      </form>

      <Modal
          v-if="showModal"
          @accept="showModal = false"
          @close="showModal = false"
      />

    </template>
  </base-layout>
</template>

<script>
import NewPromotionBaseSettingsHall from './NewPromotionBaseSettingsHall';
export default NewPromotionBaseSettingsHall;
</script>
